import styled from "styled-components";

export const QuizTitle = styled.h2`
  width: 97%;
  height: 40px;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
`;
export const QuizTitleInput = styled.input`
  width: 70%;
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
  min-height: calc(34px);
  border: none;
  /* border-bottom: 1px solid lightgray;
  padding: 5px 10px; */
  color: black;
  background-color: #f8f8f8;
  &:focus {
    border: none;
    border-bottom: 1px solid lightgray;
    outline: none;
  }
`;
export const QuizIndice = styled.div`
  width: 3%;
  /* height: 40px; */
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  margin-right: 5px;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const QuestionTitle = styled.div`
  /* height: 20px; */
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  width: 97%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;

export const QuestionTitleInput = styled(QuizTitleInput)`
  font-size: 14px;
  background: "none";
  border: none;
  min-height: 0px !important;
  margin-bottom: 0px;
  &:focus {
    border: none;
    margin-bottom: 0px;
  }
`;
export const QuestionIndice = styled.div`
  /* height: 20px; */
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  width: 3%;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const QuestionTypeList = styled.ul`
  width: fit-content;
  height: fit-content;
  background: #f8f8f8;
  z-index: 10;
  padding: 10px;
  position: absolute;
  right: 4%;
  top: 16%;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
`;
export const QuestionTypeOption = styled.li`
  list-style: none;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  padding: 5px 10px;
  &:hover {
    cursor: pointer;
    background: gray;
    color: white;
  }
`;

export const OptionTitle = styled.div`
  /* height: 20px; */
  overflow-wrap: break-word;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  width: 67%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
`;

export const OptionIndice = styled.div`
  /* height: 20px; */
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  width: 3%;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OptionValue = styled.label`
  /* height: 20px; */
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  background-color: #f8f8f8;
  width: 30%;
  margin-left: 5px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  }
`;

export const Text = styled.p`
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 300;
  margin: 0 10px;
  overflow-wrap: break-word;
  width: 90%;
`;

export const RadioInput = styled.input`
  /* Ocultar el input original */
  display: none;

  /* Estilos del icono */
  + label::before {
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #fff;
    margin-right: 5px;
    vertical-align: middle;
  }

  /* Estilos del icono seleccionado */
  &:checked + label::before {
    /* background-color: #007bff; 
    border-color: #007bff;  */
  }
`;
